// @ts-nocheck
import businessConfig from "../config/business";

// The printed menu writes units as "për kg", "2 pers.", "5 pers.".
// i18next treats "." as a key separator, so units get their own safe keys.
const UNIT_KEYS = {
    "për kg": "units.perKg",
    "2 pers.": "units.twoPersons",
    "5 pers.": "units.fivePersons",
};

export const formatUnit = (t, unit) => {
    if (!unit) return "";
    const key = UNIT_KEYS[unit];
    return key ? t(key, unit) : unit;
};

export const currency = businessConfig.currency;
